import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../features/auth/authSlice";
import { Icon } from "../designSystem";

export const ExpiredPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("podcast_session");
      dispatch(logout());
      navigate("/login");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, dispatch]);

  return (
    <div className="lt-center-state">
      <Icon name="schedule" size={36} style={{ color: "var(--text-3)" }} />
      <p>您的登录信息已过期，即将跳转到登录页面。</p>
    </div>
  );
};
